import { PackagesAppWebComponent } from './component/PackagesAppWebComponent';
import { WEB_COMPONENT_PACKAGES } from '../../webcomponents.constants';

export { PackagesAppWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGES, PackagesAppWebComponent);
